import { useMutation, useQueryClient } from '@tanstack/react-query'
import { promoteAgendaMemberService } from '@/services/agendas'

export const usePromoteAgendaMember = (agendaId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (targetUserId: string) => promoteAgendaMemberService(agendaId, targetUserId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agendas', agendaId, 'members'] })
    },
  })
}
